export default __webpack_public_path__ + "static/media/phone3.bcfa3aa7.svg";